module.exports = __webpack_public_path__ + "img/store-app-logo-transparent.9419dcd8.png";